export default {"src":"/_next/static/media/logo.aced347d.svg","height":181,"width":181};